import React, { Fragment } from "react";
import { Flex, Box } from "grid-styled";
import moment from "moment";
import Moment from "react-moment";
import PropTypes from "prop-types";
import { reduxForm, Field } from "redux-form";
import { P } from "../Text";
import InputContainer from "../forms/InputContainer";
import Checkbox from "../forms/Checkbox";
import Select from "../forms/Select";
import Option from "../Option";
import DatePicker from "../forms/DatePicker";
import { CLEAR } from "../../icons";
import * as colors from "../../settings/colors";
import { Panel, PanelHeader, PanelBody } from "../Panel";
import Button from "../Button";

const sendingMediaOptions = ["Email", "Post"].map(value => ({
  value,
  label: value
}));

const NgcForm = reduxForm({
  form: "ngcEdit"
})(({ handleSubmit, onCancel }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Box pb={2}>
        <Field
          name="ngcPackageSent"
          labelText="NGC Package Sent"
          component={Checkbox}
        />
      </Box>
      <Box pb={2}>
        <Field
          name="ngcPackageSentOn"
          labelText="NGC Package Sent On"
          component={InputContainer}
          fieldComponent={DatePicker}
          utc
        />
      </Box>
      <Box pb={2}>
        <Field
          name="ngcPackageSentVia"
          labelText="NGC Package Sent Via"
          component={InputContainer}
          fieldComponent={Select}
          options={sendingMediaOptions}
        />
      </Box>
      <Flex justify="flex-end">
        <Button type="button" onClick={onCancel} style={{ marginRight: 4 }}>
          Cancel
        </Button>
        <Button type="submit" variant="primary">
          Save
        </Button>
      </Flex>
    </form>
  );
});

class NgcCard extends React.Component {
  static propTypes = {
    job: PropTypes.object,
    onSave: PropTypes.func.isRequired
  };

  state = {
    editing: false
  };

  save = values => {
    return this.props
      .onSave({
        ...values
      })
      .then(this.toggleEdit);
  };

  toggleEdit = () => {
    this.setState({ editing: !this.state.editing });
  };

  renderForm() {
    const { job } = this.props;
    const initialValues = {
      ngcPackageSent: job.ngcPackageSent,
      ngcPackageSentOn: job.ngcPackageSentOn || moment(),
      ngcPackageSentVia: job.ngcPackageSentVia
    };
    return (
      <NgcForm
        initialValues={initialValues}
        onSubmit={this.save}
        onCancel={this.toggleEdit}
      />
    );
  }

  renderInfo() {
    const { job } = this.props;
    return (
      <Fragment>
        <P>
          <Option
            checked={job.ngcPackageSent}
            uncheckedStyles={{ icon: CLEAR, color: colors.RED }}
          >
            <b>{job.ngcPackageSent ? "Package Sent" : "Package Not Sent"}</b>
          </Option>
        </P>
        {job.ngcPackageSent && (
          <Fragment>
            <P>
              <b>Sent On</b>
              <br />
              <Moment format="MMM D, YYYY" utc>
                {job.ngcPackageSentOn}
              </Moment>
            </P>
            <P>
              <b>Sent Via</b>
              <br />
              {job.ngcPackageSentVia}
            </P>
            {job.ngcPackageSentVia === "Email" &&
              job.ngcPackageEmailStatus === "sent" && (
                <Fragment>
                  <P>
                    <b>Sent To</b>
                    <br />
                    {job.ngcPackageEmailedTo}
                  </P>
                  {job.ngcPackageEmailOpened && (
                    <P>
                      <b>Opened At</b>
                      <br />
                      <Moment format="MMM D, YYYY [at] h:mm p">
                        {job.ngcPackageEmailOpenedAt}
                      </Moment>
                    </P>
                  )}
                </Fragment>
              )}
          </Fragment>
        )}
      </Fragment>
    );
  }

  render() {
    const { editing } = this.state;
    const { onSave, ...otherProps } = this.props;
    return (
      <Panel {...otherProps}>
        <PanelHeader>
          <span>NGC</span>
          <Button
            onClick={this.toggleEdit}
            style={{ marginLeft: "auto" }}
            size="sm"
            disabled={editing}
          >
            {editing ? "Editing" : "Edit"}
          </Button>
        </PanelHeader>
        <PanelBody>{editing ? this.renderForm() : this.renderInfo()}</PanelBody>
      </Panel>
    );
  }
}

export default NgcCard;



// WEBPACK FOOTER //
// ./src/components/job/NgcCard.js